import { isSSR } from '@k2/core/util'
import type { NavigationGuardWithThis, RouteLocationNormalized, RouteLocationRaw } from 'vue-router'
import { useOrganizationStore } from '@/layout'

export const campaignWriteGuard: NavigationGuardWithThis<undefined> = async (to: RouteLocationNormalized) => {
  if (isSSR) return true

  const organizationId = to.params.organizationId
  if (typeof organizationId !== 'string') return { name: 'organizations' } as RouteLocationRaw

  const organizationStore = useOrganizationStore()
  await organizationStore.getOrLoadDetails(organizationId)
  if (organizationStore.hasRight(organizationId, 'campaign.write')) return true
  return { name: 'campaigns', params: { organizationId } } as RouteLocationRaw
}
